// 各项全局常量  cdn静态资源配置
const APPNAME = "Date Paradise"; //app名称
let domain = window.location.hostname;
let protocol = window.location.protocol;
// 获取 URL 中的端口号
let port = window.location.port;
if(port == 80 || port == 443){
	port = "";
}else{
	port = ':' + port;
}

const LIVESOCKET = "wss://"+domain+":8273/"; // 
domain = domain + port;
let BASEDOMAIN = domain;
let DEFALUTKF = 'https://www.sogou.com';
let SERVERTAPI = protocol + "//"+ domain; // 线上环境
let STATICURL = protocol + "//"+ domain; //静态资源地址 ***正式上线必须换成自己的***
let SHAREURL = protocol + "//"+ domain+"/m"; // 线上环境
const SECRETKEY = "skmuz8qec3n9fxih6g4l5j1a70dwtrpo"; //  api密钥约定，搭配md5加密在请求时生成api_token，对应后端数据表sp_secret的client_secret字段值

if (process.env.NODE_ENV === "development") {
	// SERVERTAPI = "http://woshop.com/"; // 线上环境
	// STATICURL = "http://woshop.com/static/"; //静态资源地址 ***正式上线必须换成自己的***
}


export { APPNAME, LIVESOCKET, SERVERTAPI, STATICURL, SHAREURL,SECRETKEY ,BASEDOMAIN,DEFALUTKF};
